import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "lib/api";
import { ConfirmModalContent } from "styles/elements/main";
import ProfileHeader from "modules/shared/profiles/ProfileHeader";
import { ModalComponent, ToastMessage } from "components";
import CustomTable from "modules/shared/CustomTable";
import { UpdateAccount } from "./components";
import EditDriverProfile from "./EditDriverProfile";
import ProfileData from "./components/ProfileData";
import entityOptions from "./config/entity";
import { useSelector } from "react-redux";
import { getUserRoles } from "modules/auth/slice";

function Profile() {
    const { id } = useParams();
    const [driverData, setDriverData] = useState({});
    const [creatorData, setCreatorData] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [onSuccess, setOnSuccess] = useState(false);
    const [createAccountDone, setCreateAccountDone] = useState(false);
    const [confirmCanele, setConfirmCancele] = useState(false);
    const getCurrentUserRoles = useSelector(getUserRoles());
    const isSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager");
    const customTabs = [
        {
            label: "Mobile app management",
            component: (
                <UpdateAccount
                    phoneNumber={driverData?.attributes?.phoneNumber}
                    id={driverData?.id}
                    setCreateAccountDone={setCreateAccountDone}
                />
            ),
        },
    ];
    useEffect(() => {
        axios
            .get(`drivers/${id}`, {
                params: {
                    include: `creator,${
                        isSupplierPartner ? "suppliers" : "supplier"
                    },paymentMethod,ownedTrucks`,
                },
            })
            .then((res) => {
                const includedData = res?.included;
                const paymentMethod = includedData?.filter(
                    (item) => item?.type === "paymentMethods"
                );
                const supplier = includedData
                    ?.filter((item) => item?.type === "suppliers")
                    .map((item) => item?.attributes?.name);
                const driver = {
                    ...res.data,
                    paymentMethod: { ...paymentMethod?.[0]?.attributes },
                    supplier,
                };
                for (let i = 0; i < includedData?.length; i++) {
                    if (includedData[i]?.type === "creators") {
                        setCreatorData({
                            ...includedData[i]?.attributes,
                            createdAt: res?.data?.attributes?.createdAt,
                        });
                    }
                }
                setDriverData({ ...driver });
            });
    }, [id]);
    const handleCloseModal = () => setOpenModal(false);
    const handleCanceleEdit = () => setConfirmCancele(true);
    return (
        <>
            <ProfileHeader
                id={driverData?.id}
                name={driverData?.attributes?.name}
                image={driverData?.attributes?.photo?.url}
                creatorContent={creatorData}
                setOpenModal={setOpenModal}
                entityName="driver"
            />
            <ProfileData data={driverData} />
            <EditDriverProfile
                open={openModal}
                onClose={handleCloseModal}
                handleDiscardEdit={handleCanceleEdit}
                driverId={id}
            />
            <ModalComponent
                header={<h3 style={{ paddingLeft: "18px" }}>Leave “Edit Location” Page</h3>}
                open={confirmCanele}
                onClose={() => {
                    setOpenModal(true);
                    setConfirmCancele(false);
                }}
                onSubmit={() => {
                    setOpenModal(false);
                    setConfirmCancele(false);
                }}
                submitBtnText="Leave"
                submitBtn
                cancelBtn
                isFooter
            >
                <ConfirmModalContent>
                    You have unsaved changes that will be lost if you leave the page.
                </ConfirmModalContent>
            </ModalComponent>
            {onSuccess && (
                <ToastMessage
                    name="driver"
                    type="success"
                    showToast={onSuccess}
                    setShowToast={setOnSuccess}
                    text="info edits have been submitted successfully."
                />
            )}
            <CustomTable
                entityOptions={entityOptions}
                customTabs={customTabs}
            />
            {createAccountDone && (
                <ToastMessage
                    name="driver account"
                    type="success"
                    showToast={createAccountDone}
                    setShowToast={setCreateAccountDone}
                    text="has been created successfully and is pending
                    verification."
                />
            )}
        </>
    );
}

export default Profile;
